import React, { useState } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { FcGoogle } from 'react-icons/fc';
import { useLanguage } from '../../Translations/LenguageContext';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../Components/Spinner';
import ErrorMessage from '../../Components/ErrorMessage';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const GoogleLogin = ({ type_enter }) => {
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()
    const { t } = useLanguage()
    const [error, setError] = useState(null);

    const loginWithFirebase = () => {
        const provider = new GoogleAuthProvider();

        signInWithPopup(auth, provider)
            .then((result) => {
                const user = result.user;
                const nameParts = user.displayName.split(' ');
                const firstName = nameParts[0];
                const lastName = nameParts.slice(1).join(' ');
                check_email(user.email, firstName, lastName);
            })
            .catch((error) => {
                console.error("Login error:", error);
                setError("Login failed. Please try again.");
            });
    };

    const check_email = (email, name, surname) => {
        setLoading(true)
        fetch('https://backend.erioon.com/google_login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, name, surname }),
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false)
                if (data.message === "OK") {
                    const user_id = data.user_id;

                    sessionStorage.setItem("user_id", user_id);
                    navigate("/control_panel/projects");
                } else if (data.message === "Invalid_email_or_password") {
                    setErr({ message: t.register_form.invalid_email_pass, display: true });
                } else if (data.message === "email_not_valid") {
                    setErr({ message: t.register_form.email_format, display: true });
                } else if (data.message === "account_not_exists") {
                    setErr({ message: "Account does not exist. Please register first.", display: true });
                } else if (data.error) {
                    setErr({ message: t.register_form.errors_back, display: true });
                }
                console.log(data)
            })
            .catch((error) => {
                setLoading(false)
            });
    };

    return (
        <>
        <button className="reg_auth_ext_btn" onClick={loginWithFirebase}>
            {loading ? (
                <Spinner loading={loading} />
            ) : (
                <>
                    <i><FcGoogle /></i> {type_enter} with Google
                </>
            )
        }
        </button>
        <ErrorMessage err={err} />
        </>

    );
};

export default GoogleLogin;
